import React from 'react';
import CustomerTradersList from './CustomerTradersList';
import CustomerTradersAdd from './CustomerTradersAdd';

export default function CustomerTradersSettings({ crm_trader, type } = {}) {
  if (type === 'add' || type === 'edit') {
    return <CustomerTradersAdd crm_trader={crm_trader} type={type} />;
  }
  return <CustomerTradersList />;
}
